export function getInitials(name: string, count = 2): string {
    const initials = name
        .split(' ')
        .map((match) => match.substring(0, 1).toUpperCase())
        .slice(0, count)
        .join('');

    return initials;
}
